/* eslint-disable no-undef */
import axios from 'axios'
import * as types from '../constantes/job'
import { DispatchListJobsAction, ListJobsActionProps } from '../../types/redux/listJobs'
import { DispatchSearchSpecifyJobAction, SearchSpecifyJobActionProps } from '../../types/redux/searchSpecifyJob'
import { CreateJobActionProps, DispatchCreateJobAction } from '../../types/redux/createJob'
import { DispatchUpdateJobAction, UpdateJobActionProps } from '../../types/redux/updateJob'
import { DispatchUploadJobAction, UploadJobActionProps } from '../../types/redux/uploadJob'

export const ListJobsAction: ListJobsActionProps = () => async (dispatch: DispatchListJobsAction) => {
  dispatch({
    type: types.LIST_JOBS_REQUEST
  })

  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/`)
    dispatch({
      type: types.LIST_JOBS_SUCCESS,
      payload: data
    })
  } catch (error) {
    if (axios.isAxiosError(error)) {
      dispatch({
        type: types.LIST_JOBS_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message
      })
    }
  }
}

export const SearchSpecifyJobAction: SearchSpecifyJobActionProps =
  _id => async (dispatch: DispatchSearchSpecifyJobAction) => {
    dispatch({
      type: types.SEARCH_SPECIFY_JOB_REQUEST,
      payload: _id
    })

    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/${_id}`)
      dispatch({
        type: types.SEARCH_SPECIFY_JOB_SUCCESS,
        payload: data
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.SEARCH_SPECIFY_JOB_ERROR,
          payload: error.response && error.response.data ? error.response.data : error.message
        })
      }
    }
  }

export const CreateJobAction: CreateJobActionProps =
  (
    Key,
    Cargo,
    Local,
    Area,
    Modalidade,
    Salario,
    Descricao,
    Atividades,
    Requisitos,
    Beneficios,
    QuestionOne,
    QuestionTwo,
    QuestionThree
  ) =>
  async (dispatch: DispatchCreateJobAction) => {
    dispatch({
      type: types.CREATE_JOB_REQUEST,
      payload: {
        Key,
        Cargo,
        Local,
        Area,
        Modalidade,
        Salario,
        Descricao,
        Atividades,
        Requisitos,
        Beneficios,
        QuestionOne,
        QuestionTwo,
        QuestionThree
      }
    })

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/jobs/`, {
        Key,
        Cargo,
        Local,
        Area,
        Modalidade,
        Salario,
        Descricao,
        Atividades,
        Requisitos,
        Beneficios,
        QuestionOne,
        QuestionTwo,
        QuestionThree
      })
      dispatch({
        type: types.CREATE_JOB_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.CREATE_JOB_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

export const UpdateJobAction: UpdateJobActionProps =
  (
    _id,
    Key,
    Cargo,
    Local,
    Area,
    Modalidade,
    Salario,
    Descricao,
    Atividades,
    Requisitos,
    Beneficios,
    QuestionOne,
    QuestionTwo,
    QuestionThree,
    IsActive
  ) =>
  async (dispatch: DispatchUpdateJobAction) => {
    dispatch({
      type: types.UPDATE_JOB_REQUEST,
      payload: {
        _id,
        Key,
        Cargo,
        Local,
        Area,
        Modalidade,
        Salario,
        Descricao,
        Atividades,
        Requisitos,
        Beneficios,
        QuestionOne,
        QuestionTwo,
        QuestionThree,
        IsActive
      }
    })

    try {
      const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/jobs/${_id}`, {
        Key,
        Cargo,
        Local,
        Area,
        Modalidade,
        Salario,
        Descricao,
        Atividades,
        Requisitos,
        Beneficios,
        QuestionOne,
        QuestionTwo,
        QuestionThree,
        IsActive
      })
      dispatch({
        type: types.UPDATE_JOB_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.UPDATE_JOB_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

export const UploadJobAction: UploadJobActionProps =
  (file, Name, Area, CellPhone, QuestionOne, RespOne, QuestionTwo, RespTwo, QuestionThree, RespThree) =>
  async (dispatch: DispatchUploadJobAction) => {
    dispatch({
      type: types.UPLOAD_JOB_REQUEST,
      payload: {
        file,
        Name,
        Area,
        CellPhone,
        QuestionOne,
        RespOne,
        QuestionTwo,
        RespTwo,
        QuestionThree,
        RespThree
      }
    })
    const bodyFormData = new FormData()
    bodyFormData.append('file', file as File)
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/jobs/upload/${Name}/${Area}/${CellPhone}
        ${QuestionOne !== '' ? `/${QuestionOne}` : ''}
        ${RespOne !== '' ? `/${RespOne}` : ''}
        ${QuestionTwo !== '' ? `/${QuestionTwo}` : ''}
        ${RespTwo !== '' ? `/${RespTwo}` : ''}
        ${QuestionThree !== '' ? `/${QuestionThree}` : ''}
        ${RespThree !== '' ? `/${RespThree}` : ''}`,
        bodyFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      dispatch({
        type: types.UPLOAD_JOB_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.UPLOAD_JOB_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }
